// extracted by mini-css-extract-plugin
export var icon = "s-module--icon--33c35";
export var multiItemBlockItem = "s-module--multiItemBlockItem--f3028";
export var multiItemBlockItemWrapper = "s-module--multiItemBlockItemWrapper--ebe44";
export var title = "s-module--title--436b5";
export var titleSmall = "s-module--titleSmall--c3043";